import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import GoogleSignInButton from "@/components/loomi/GoogleSignInButton";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(email.trim().toLowerCase(), password, name.trim());
    setLoading(false);
    if (!res.ok) { toast.error("Registration failed", { description: res.error }); return; }
    toast.success(`Welcome to SyncLine, ${res.user.name}`);
    nav("/panel", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white relative overflow-hidden flex items-center justify-center p-6" data-testid="panel-register-page">
      <div className="aurora" />
      <form onSubmit={onSubmit} className="glass rounded-2xl p-8 w-full max-w-md relative overflow-hidden z-10">
        <div className="absolute -top-24 -right-24 w-56 h-56 rounded-full bg-gradient-to-br from-emerald-500/25 to-indigo-500/10 blur-3xl" />
        <Link to="/" className="flex items-center gap-2 mb-6" data-testid="register-logo">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-fuchsia-500 flex items-center justify-center">
            <Sparkles className="w-4 h-4" />
          </div>
          <span className="font-display font-extrabold text-xl">SyncLine</span>
        </Link>
        <div className="text-xs uppercase tracking-widest text-mute mb-2">Panelist</div>
        <h2 className="font-display font-extrabold text-3xl mb-6">Join the panel</h2>
        <label className="block text-xs uppercase tracking-widest text-mute mb-1.5">Full name</label>
        <input data-testid="panel-register-name" required value={name} onChange={(e) => setName(e.target.value)}
          className="w-full bg-black/50 border border-white/10 rounded-md px-3 py-2.5 mb-4 focus:border-indigo-400 focus:outline-none focus:ring-1 focus:ring-indigo-400" />
        <label className="block text-xs uppercase tracking-widest text-mute mb-1.5">Email</label>
        <input data-testid="panel-register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-black/50 border border-white/10 rounded-md px-3 py-2.5 mb-4 focus:border-indigo-400 focus:outline-none focus:ring-1 focus:ring-indigo-400" />
        <label className="block text-xs uppercase tracking-widest text-mute mb-1.5">Password (min 6)</label>
        <input data-testid="panel-register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-black/50 border border-white/10 rounded-md px-3 py-2.5 mb-5 focus:border-indigo-400 focus:outline-none focus:ring-1 focus:ring-indigo-400" />
        <button disabled={loading} data-testid="panel-register-submit" className="w-full bg-indigo-500 hover:bg-indigo-400 disabled:opacity-60 px-4 py-2.5 rounded-md font-medium flex items-center justify-center gap-2 shadow-[0_0_30px_rgba(79,70,229,0.35)]">
          {loading ? "Creating…" : (<>Create account <ArrowRight className="w-4 h-4" /></>)}
        </button>
        <div className="mt-5 flex items-center gap-3 text-[10px] uppercase tracking-widest text-mute">
          <div className="flex-1 h-px bg-white/10" />
          <span>or</span>
          <div className="flex-1 h-px bg-white/10" />
        </div>
        <div className="mt-4">
          <GoogleSignInButton testId="panel-register-google" label="Sign up with Google" />
        </div>
        <div className="mt-5 text-xs text-mute text-center">
          Already registered? <Link to="/panel/login" className="text-white underline" data-testid="register-to-login">Log in</Link>
        </div>
      </form>
    </div>
  );
}
